module.exports = __webpack_public_path__ + "img/671.3de0477d.jpg";